import React from "react";
import styled from "styled-components/native";

import { useColorMode, themeTools, View } from "native-base"
import { extractSpacingProps } from "../utils";


export const Row = React.memo(({ rowTheme, ...props }) => {
    const spacingProps = extractSpacingProps(props)[0] ?? {};

    const themeProps = {
        light: (padding) => ({
            padding: padding ?? 4,
            borderWidth: props.borderWidth ?? "2px",
            borderStyle: "solid",
            boxShadow: "none",
            backgroundColor: props.backgroundColor ?? themeTools.mode("light.50", "dark.50")(props)
        }),
        dark: (padding) => ({
            padding: padding ?? 4,
            borderWidth: props.borderWidth ?? "2px",
            borderStyle: "solid",
            boxShadow: "none",
            backgroundColor: props.backgroundColor ?? themeTools.mode("gray.200", "gray.500")(props)
        }),
    }

    const rowProps = {
        borderRadius: props.borderRadius ?? 8,
        borderColor: props.borderColor ?? "muted.100",
        ...spacingProps,
        width: props.width ?? "100%",
        flexDirection: 'row',
        ...themeProps[rowTheme]?.(spacingProps.padding),
    }


    return <View colorMode={ useColorMode().colorMode } { ...props } {...rowProps} />
})

